import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';
import { NgxBottomNavigationService } from '@digipay/ngx-bottom-navigation';
import { RouterAnimation } from '@client-monorepo/common/animations';

@Component({
  selector: 'dpx-no-navigation',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './no-navigation.component.html',
  styleUrl: './no-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
  animations: RouterAnimation,
})
export class NoNavigationComponent implements OnInit {
  bottomNavigationService = inject(NgxBottomNavigationService);
  routeContext = inject(ChildrenOutletContexts);
  ngOnInit() {
    setTimeout(() => {
      this.bottomNavigationService.hide();
    }, 0);
  }

  prepareRoute() {
    return this.routeContext.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }
}
